import Application from "../../Application";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import CreateCourtCaseConnectionTypeInteractor from "../interactor/CreateCourtCaseConnectionTypeInteractor";
import GetAllCourtCaseConnectionTypesInteractor from "../interactor/GetAllCourtCaseConnectionTypesInteractor";
import UpdateCourtCaseConnectionTypeInteractor from "../interactor/UpdateCourtCaseConnectionTypeInteractor";
import { ICourtCaseConnectionType } from "../model/CourtCaseConnectionType";

export interface TCourtCaseConnectionTypePresenter
  extends TLoadingAwarePresenter {
  courtCaseConnectionTypeList: ICourtCaseConnectionType[];
}

export interface ICourtCaseConnectionTypePresenter
  extends TCourtCaseConnectionTypePresenter,
    TPresentable {
  loadAllCourtCaseConnectionTypes(
    courtCaseConnectionTypeList: ICourtCaseConnectionType[]
  ): void;
  createCourtCaseConnectionType(
    courtCaseConnectionType: ICourtCaseConnectionType
  ): void;
  updateCourtCaseConnectionType(
    courtCaseConnectionType: ICourtCaseConnectionType
  ): void;
}

const defaultState: TCourtCaseConnectionTypePresenter = {
  courtCaseConnectionTypeList: []
};

const CourtCaseConnectionTypePresenter = withStore<
  ICourtCaseConnectionTypePresenter,
  TCourtCaseConnectionTypePresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): ICourtCaseConnectionTypePresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TCourtCaseConnectionTypePresenter>();
    loader.start("courtCaseConnectionTypeLoader");

    const loadAllCourtCaseConnectionTypes = (
      courtCaseConnectionTypeList: ICourtCaseConnectionType[]
    ) => {
      _store.update({ courtCaseConnectionTypeList });
      loader.stop("courtCaseConnectionTypeLoader");
    };

    const getAllCourtCaseConnectionTypes = async () => {
      let courtCaseConnectionTypeList = await _application.container
        .resolve<GetAllCourtCaseConnectionTypesInteractor>(
          "getAllCourtCaseConnectionTypes"
        )
        .execute();
      _store.update({ courtCaseConnectionTypeList });
      loader.stop("courtCaseConnectionTypeLoader");
    };

    const createCourtCaseConnectionType = async (
      connectionType: ICourtCaseConnectionType
    ) => {
      loader.start("courtCaseConnectionTypeLoader");

      await _application.container
        .resolve<CreateCourtCaseConnectionTypeInteractor>(
          "createCourtCaseConnectionType"
        )
        .execute(connectionType);
      getAllCourtCaseConnectionTypes();
      loader.stop("courtCaseConnectionTypeLoader");
    };

    const updateCourtCaseConnectionType = async (
      connectionType: ICourtCaseConnectionType
    ) => {
      loader.start("courtCaseConnectionTypeLoader");

      await _application.container
        .resolve<UpdateCourtCaseConnectionTypeInteractor>(
          "updateCourtCaseConnectionType"
        )
        .execute(connectionType);
      getAllCourtCaseConnectionTypes();
      loader.stop("courtCaseConnectionTypeLoader");
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadAllCourtCaseConnectionTypes,
      createCourtCaseConnectionType,
      updateCourtCaseConnectionType
    };
  },
  defaultState
);

export default CourtCaseConnectionTypePresenter;
